module.exports = __webpack_public_path__ + "img/itunes.0502b743.png";